const SET_USERINFO = "SET_USERINFO";

export default {
	[SET_USERINFO] (state, payload) {
		state.userInfo = payload;
	}
}




// WEBPACK FOOTER //
// ./src/store/mutations.js